import { client } from 'lib/graphql/client';
// import { getMarket } from 'modules/localesMapper';
import {
  GetHeaderDocument,
  GetHeaderQuery,
  GetHeaderQueryVariables,
  GetMobileHeaderDocument,
  GetMobileHeaderQuery,
  GetMobileHeaderQueryVariables,
} from 'generated/graphql';

import { getLocalesForGraphQL } from '../utils/helpers';

export async function getHeaderNavCMSData(locale: string) {
  // const market = getMarket(locale);
  return client.query<GetHeaderQuery, GetHeaderQueryVariables>({
    query: GetHeaderDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        // market: market as Markets,
      },
    },
  });
}

export async function getMobileOnlyCMSData() {
  // locale: string,
  // const market = getMarket(locale);
  return client.query<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>({
    query: GetMobileHeaderDocument,
    variables: {
      where: {
        key: 'PrimaryNavAsset',
        // market: market as Markets,
      },
    },
  });
}
